import { createSelector } from '@reduxjs/toolkit';
import menusSelector from './menus';

const selectedMenuItemSelector = createSelector(menusSelector, (menus) => menus.selectedItem);

export default selectedMenuItemSelector;
